import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { Router } from "@angular/router";
import { environment } from "../../environments/environment";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { CookieService } from "ngx-cookie-service";

export const tokenInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const cookieService = inject(CookieService);

  // Don't intercept requests to other domains
  if (!(req.url && req.url.startsWith(environment.venway3ApiHost))) {
    return next(req);
  }

  // Allow /ping and /login to pass through without authentication
  if (req.url.indexOf('/ping') > -1 || req.url.indexOf('/login') > -1) {
    return next(req);
  }

  // Check if user is authorized
  if (authService.checkAuthorization()) {
    req = req.clone({
      withCredentials: true,
      setHeaders: {
        'Content-Type': req.headers.has("Content-Type")
          ? req.headers.get("Content-Type")!
          : 'application/json',
        'Accept': req.headers.has("Accept")
          ? req.headers.get("Accept")!
          : 'application/json'
      }
    });

    return next(req).pipe(
      catchError((error) => {
        // Handle 401 Unauthorized responses
        if (error.status === 401) {
          // Clear cookies and redirect to login
          cookieService.delete('enoc_session', '/', environment.cookieDomain);
          cookieService.delete('oadr_login');
          router.navigate(['/login']);
        }
        return throwError(() => error);
      })
    );
  } else {
    router.navigate(["/login"]);
    return throwError(() => new Error('Unauthorized - redirecting to login'));
  }
};
